import { render, staticRenderFns } from "./create-workspace-form.vue?vue&type=template&id=5432a9d0&scoped=true&"
import script from "./create-workspace-form.vue?vue&type=script&lang=ts&"
export * from "./create-workspace-form.vue?vue&type=script&lang=ts&"
import style0 from "./create-workspace-form.vue?vue&type=style&index=0&id=5432a9d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5432a9d0",
  null
  
)

/* custom blocks */
import block0 from "./create-workspace-form.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports